import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  queryLiveTime?: Date
  pageSize: number
  pageNo: number
  categoryId: number | null
  merchantId: number | string
  showInvalid?: 1
}

class FetchMerchantProductListApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_MERCHANT_PRODUCT_LIST'

    this.config = {
      url: `/v1/product/merchant/${params.merchantId}`,
      method: 'GET',
      params: { ...params },
    }
  }
}

export const fetchMerchantProductList = (params: ParamsType) => getCallApiFunction(new FetchMerchantProductListApi(params))
